export interface Configuration {
  urlApiSiVisionV1: string;
  urlApiSiretManagement: string;
  urlApiMsOrder: string;
  urlBusinessManagement: string;
  urlApiCloudManagement: string;
  authentication?: AppAuthConfig;
  shineMigrationOlStartDate?: string;
  shineMigrationOtherStartDate?: string;
  migrationFeatureEndDate?: string;
  shineMigrationFactureEbpUrl?: string;
  expireDomainByHours?: number;
}

export const EMPTY_CONFIGURATION: Configuration = {
  urlApiSiVisionV1: '',
  urlApiSiretManagement: '',
  urlApiMsOrder: '',
  urlBusinessManagement: '',
  urlApiCloudManagement: '',
};

export interface AppAuthConfig {
  issuer: string;
  clientId: string;
  scope: string;
}
